module.exports = __webpack_public_path__ + "img/fabric-slide-1-s.e6c1d51.webp";